import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { useCurrentEvent } from './eventContext'

const isTeamMode = (mode: string): boolean =>
  mode === 'SCRAMBLE' || mode === 'BESTBALL'

const TeamsModeGuard = ({ children }: { children: ReactNode }) => {
  const event = useCurrentEvent()
  if (!isTeamMode(event.mode)) {
    return <Navigate to={`/events/${event.id}/summary`} replace />
  }
  return children
}

export default TeamsModeGuard
